/**
 * Past calendar days must not receive arrival / period band visual statuses (T7.130).
 * Compare ISO `yyyy-MM-dd` strings lexicographically (valid for that format).
 */
export function isPastAvailabilityDay(dateIso: string, todayIso: string): boolean {
  return dateIso < todayIso
}
